import React from 'react';
import Loader from 'react-loader-spinner'

export default class Loadergf extends React.Component {
  constructor(props) {
    super(props);
    this.Hide = this.Hide.bind(this);
    this.Show = this.Show.bind(this);
}

Hide(e){
  var dv = document.getElementById('dv_ldr_spn');
  dv.classList.add('Hide_All');
}

Show(e){
  var dv = document.getElementById('dv_ldr_spn');
  dv.classList.remove('Hide_All');
}

  render() {
    return(
        <div className="dv_Ldr Hide_All" id="dv_ldr_spn">
          <Loader type="Circles" color="#F5A796" height="150" width="150" />   
          <button onClick={(e)=>this.Hide(e)} id='btn_hide' className='Hide_All'>Hide</button>
          <button onClick={(e)=>this.Show(e)} id='btn_show' className='Hide_All'>Show</button>
        </div>  
       );
  }
}